import io from 'socket.io-client';
import axios from 'axios';
import qs from 'qs';
var _ = require('lodash');

const SOCKET_URL = process.env.VUE_APP_API_PROFILE_URL; //'https://ws-node-1.softsq.com'; // 'https://autoassign-dev.softsq.com'
const API_CHAT = process.env.VUE_APP_API_CHAT;
let _socket = null;
let _promiseConnect = null;

export const Status = {
  ONLINE: 'online',
  BUSY: 'busy',
};

export default {
  namespaced: true,
  state: {
    connect: false,
    profile: null,
    profileLoading: false,
    status: null,
    statusLoading: false,
    allTags: [],
  },
  mutations: {
    SOCKET_CONNECT(state, socket) {
      state.connect = true;
      _socket = socket;
    },
    SOCKET_PROFILE(state, { nickName, fullName, status, reservationId }) {
      state.profile = {
        nickName,
        fullName,
        status,
        reservationId,
        sex:
          reservationId == '13582' ||
          reservationId == '14368' ||
          reservationId == '14467'
            ? 'M'
            : 'W',
        urlProfile: 'https://mushbot-static.softsq.com/mushroom_logo.jpg',
      };
      state.profileLoading = false;
    },
    SOCKET_STATUS(state, data) {
      state.status = data;
      state.statusLoading = false;
    },
    SOCKET_DISCONNECT(state) {
      console.log('socket profile disconnect!!');
      state.connect = false;
      _socket.close();
    },
    LOADING(state, { stateName, status }) {
      state[stateName + 'Loading'] = status;
    },
    SET_ALLTAGS(state, data) {
      state.allTags = data;
    },
  },
  actions: {
    connect({ state, commit }) {
      if (_promiseConnect) {
        return _promiseConnect;
      } else {
        _promiseConnect = new Promise(resolve => {
          const socket = io.connect(SOCKET_URL, {
            transports: ['websocket'],
          });
          function handleReconnection() {
            let isConnected = socket.connected;
            const reconnectInterval = 1000; // Set the reconnection interval (1 second)

            // Check the socket connection status periodically
            setInterval(() => {
              // If the socket is not connected, try to reconnect
              if (!isConnected) {
                console.log('Trying to reconnect...');
                socket.connect();
              }

              // Update the connection status
              isConnected = socket.connected;
            }, reconnectInterval);
          }
          socket.on('connect', () => {
            socket.on('resultloadReservationData', function(data) {
              commit('SOCKET_PROFILE', data);
            });
            socket.on('resultReservationStatus', function(status) {
              commit('SOCKET_STATUS', status);
            });
            socket.on('disconnect', function() {
              commit('SOCKET_DISCONNECT');
              handleReconnection();
            });
            commit('SOCKET_CONNECT', socket);
            resolve();
          });
        });
        return _promiseConnect;
      }
    },
    disconnect({ commit }) {
      commit('SOCKET_DISCONNECT');
    },
    loadProfile({ rootState, commit }) {
      if (!_socket) {
        throw new Error("profile socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }
      commit('LOADING', {
        stateName: 'profile',
        status: true,
      });
      _socket.emit('loadReservationData', rootState.reservationId);
    },
    loadStatus({ rootState, commit }) {
      if (!_socket) {
        throw new Error("profile socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }
      commit('LOADING', {
        stateName: 'status',
        status: true,
      });
      _socket.emit('checkReservationStatus', rootState.reservationId);
    },
    loadAllTags({ rootState, commit }) {
      if (!_socket) {
        throw new Error("profile socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }
      const options = {
        method: 'GET',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: API_CHAT + '/getTagsAll',
      };
      return new Promise(resolve => {
        axios(options)
          .then(function(response) {
            if (response.data && response.data.length > 1) {
              commit('SET_ALLTAGS', response.data);
            }
            resolve();
          })
          .catch(function(error) {
            console.log('error', error);
          });
      });
    },
    saveTagsCustomer({ rootState, commit }, obj) {
      if (!_socket) {
        throw new Error("profile socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        url: API_CHAT + '/setCustomerTags',
        data: obj,
      };
      return new Promise(resolve => {
        axios(options)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            console.log('error', error);
          });
      });
    },
    getTagOfCustomer({ rootState }, cusId) {
      if (!_socket) {
        throw new Error("profile socket don't have connection");
      }
      if (!rootState.reservationId) {
        throw new Error('Reservation Id is invalid');
      }
      const obj = {
        customerId: cusId,
      };
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: API_CHAT + '/getCustomerTagsByCustomerId',
        data: qs.stringify(obj),
      };
      return new Promise(resolve => {
        axios(options)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            console.log('error', error);
          });
      });
    },
  },
  getters: {
    profile: state => {
      return state.profile;
    },
    profileLoading: state => {
      return state.profileLoading;
    },
    status: state => {
      return state.status;
    },
    statusLoading: state => {
      return state.statusLoading;
    },
    statusIsOnline: state => {
      return state.status == Status.ONLINE;
    },
    statusIsBusy: state => {
      return state.status == Status.BUSY;
    },
    statusIsOffline: state => {
      return !state.status;
    },
    tagAlls: state => {
      return state.allTags;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Profile.js